import {SetupContext} from "@vue/composition-api";
import axios from "axios";
import {SettingsContext} from "@/utilities/settings-context";
import {Route} from "vue-router/types/router";
import $ from 'jquery';

export interface ImBoxCategory {
    name: string;
    id: string;
}

export interface ImBoxSetting {
    category?: ImBoxCategory;
    article?: string;
}

interface ImBoxRoute extends ImBoxSetting {
    popup: boolean;
    params: Record<string, ImBoxRoute>;
}

interface ImBoxSettings {
    automated: {[key: string]: ImBoxRoute};
    buttons: {[key: string]: ImBoxSetting};
}

interface GlobalWindow extends Window {

    _imbox?: Array<Array<string|Function>>;
}

declare const window: GlobalWindow;

let currentSetting: ImBoxRoute = null as unknown as ImBoxRoute;

let imBoxSettings: {settingsUrl: string; log: boolean} = null as unknown as {settingsUrl: string; log: boolean};

let settings: ImBoxSettings = null as unknown as ImBoxSettings;

let helpButton: JQuery<HTMLElement> = null as unknown as JQuery<HTMLElement>;

let pageBar: JQuery<HTMLElement> = null as unknown as JQuery<HTMLElement>;

let imBoxElement: JQuery<HTMLElement> = null as unknown as JQuery<HTMLElement>;

function detectImBox()
{
    imBoxElement = imBoxElement && imBoxElement[0] ? imBoxElement : $('.imbox-frame.imbox-show');

    return imBoxElement.length !== 0;
}

export function setImBoxPosition(top?: string, right?: string) {

    helpButton = helpButton ?? $('#global-help-btn');

    pageBar = pageBar ?? $('#page-bar');

    imBoxElement = imBoxElement ?? $('.imbox-frame.imbox-show');

    if (helpButton[0] && pageBar[0] && imBoxElement[0]) {

        const helpRect = helpButton[0].getBoundingClientRect();

        const pageBarRect = pageBar[0].getBoundingClientRect();

        imBoxElement[0].style.setProperty('top', top ?? `${pageBarRect.y + pageBarRect.height}px`, 'important');

        imBoxElement[0].style.setProperty('right', right ?? `${pageBarRect.width - (helpRect.x + helpRect.width)}px`, 'important');
    }
}

export function close() {

    try {

        (window._imbox as Array<string[]>).push(['hideWidget']);

        const value: { isOpen: boolean } = JSON.parse(sessionStorage['imbox-widget']);

        value.isOpen = false;

        sessionStorage['imbox-widget'] = JSON.stringify(value);
    }
    catch
    {
        //
    }
}

function isOpen() {

    try {

        const value: { isOpen: boolean } = JSON.parse(sessionStorage['imbox-widget']);

        return typeof (value.isOpen as unknown) === 'boolean' ? value.isOpen : false;
    }
    catch
    {
        return false;
    }
}

export function trigger(button?: string, automated?: boolean) {

    if (!detectImBox()) {

        const timer = setInterval(() => {

            if (detectImBox()) {

                clearInterval(timer);

                setImBoxPosition();
            }

        }, 50);
    }

    setImBoxPosition();

    if (!automated && isOpen())
    {
        close();

        return;
    }

    const route: ImBoxSetting = settings.buttons[button as string] ?? currentSetting;

    if(imBoxSettings?.log) {

        console.log(`Office: Triggered with ${JSON.stringify(route, null, 2)}`);
    }

    window._imbox?.push([...(!route.category && !route.article ? ['openFAQ'] : route.article ? ['openFAQArticle', route.article] : route.category ? ['openFAQCategory', route.category.id, route.category.name] : ['openFAQ'])]);
}

export function offsetTrigger(button: string, top: string, right: string) {

    trigger(button);

    setTimeout(() => setImBoxPosition(top, right), 50);
}

export async function init(context: SetupContext) {

    window._imbox = window._imbox || [];

    window._imbox.push(['hideLauncher']);

    imBoxSettings = SettingsContext.get<{settingsUrl: string; log: boolean}>('imbox');

    settings = (await axios.get<ImBoxSettings>(`${imBoxSettings.settingsUrl}`, {headers: {hidden: true}})).data;

    const defaultSetting = settings.automated['*'];

    function setCurrentSetting(route: Route)
    {
        let setting: ImBoxRoute = null as unknown as ImBoxRoute;

        let name: string = null as unknown as string;

        if (route.name)
        {
            setting = settings.automated[route.name];

            name = `name: "${route.name}"`;

            if (setting?.params && route?.params && Object.keys(setting.params).filter(param => typeof route.params[param] !== 'undefined').length > 0)
            {
                const paramName = Object.keys(setting.params).filter(param => typeof route.params[param] !== 'undefined').slice(-1)[0];

                setting = setting.params[paramName];

                name = `${name} - param: "${paramName}"`;
            }
        }

        currentSetting = setting ?? defaultSetting;

        if(imBoxSettings?.log) {

            console.log(`Office: Page: (name: "${route.name}" - params: [${route.params ? Object.keys(route.params).filter(name => name.trim() !== '').join(', ') : ''}]) - Loads: (${setting ? name : '"*"'}).`);
        }
    }

    function onNavigate(route: Route) {

        setCurrentSetting(route);

        if (currentSetting.popup) {

            trigger(undefined, true);
        }
    }

    close();

    onNavigate(context.root.$route);

    context.root.$router.beforeEach((to, from, next) => {

        close();

        next();
    });

    context.root.$router.afterEach((route: Route) => {

        onNavigate(route);
    });
}
